/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_TitleInputs */

const cs_contracts_title = /** @type {(inputs: Contracts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouvy`)
};

const en_contracts_title = /** @type {(inputs: Contracts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracts`)
};

/**
* | output |
* | --- |
* | "Contracts" |
*
* @param {Contracts_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_title = /** @type {((inputs?: Contracts_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_title(inputs)
	return cs_contracts_title(inputs)
});